import { SortOrder } from "src/app/shared/types/sort.order";

export class GetFundRangeSurveysCommand {
  constructor(
    public page: number = 1,
    public pageSize: number = 25,
    public fundRange: string = '',
    public sortBy: string = '',
    public sortOrder: SortOrder) { }
}
